import { Component, Input, OnInit } from '@angular/core';
import { InfoPostNotice, NoticeFilterRequest } from '@gms/reporting-api';
import { select, Store } from '@ngrx/store';
import { CommonModule } from 'app/common.module';
import { getNoticesByTspId, selectExcludeInfoPostTsp, selectNoticeLoading } from 'app/store/infopost/infopost.selectors';
import { IInfoPostState } from 'app/store/infopost/infopost.state';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CardModule } from 'shared/components/card/card.module';
import { FileSelectService } from 'shared/components/form/file-select/file-select.service';
import { HasSubscriptions } from 'shared/components/higher-order/has-subscriptions';
import { LoadingSpinnerModule } from 'shared/components/loading-spinner/loading-spinner.module';
import { InformationalWebLabels } from '../../informational-posting-web.utils';
import { fetchAllNotices } from 'app/store/infopost/infopost.actions';
import { getPagination } from 'shared/models/pagination.model';
import { isNullOrUndefined } from 'shared/utils/type.utils';
import { ServiceProvider } from '@gms/tsp-api';
import { ErrorPanelModule } from 'shared/components/error-panel/error-panel.module';

@Component({
  selector: 'app-infopost-notice-info-card',
  standalone: true,
  imports: [CommonModule, CardModule, LoadingSpinnerModule, ErrorPanelModule],
  templateUrl: './infopost-notice-info-card.component.html',
  styleUrl: './infopost-notice-info-card.component.scss',
})
export class InfopostNoticeInfoCardComponent extends HasSubscriptions implements OnInit {
  @Input() selectedTsp: ServiceProvider;

  title: string = InformationalWebLabels.POSTING_CRITICAL_NOTICE_INFO;

  errorMessage: string;

  isLoading$: Observable<boolean> = this._store.pipe(
    select(selectNoticeLoading),
    map((notice) => {
      return notice;
    })
  );

  execludeTsp$: Observable<boolean> = this._store.pipe(
    select(selectExcludeInfoPostTsp),
    filter((data) => !isNullOrUndefined(data)),
    map(excludeTsp =>{
      return excludeTsp.some((x) => x.providerId === this.selectedTsp?.providerId);
    })
  );

  notices$: Observable<InfoPostNotice[]>;

  constructor(private _store: Store<IInfoPostState>, private _fileService: FileSelectService) {
    super();
  }

  ngOnInit(): void {
    this.errorMessage = InformationalWebLabels.NOT_APPLIED_TSP_FOR_WEBSITE.replace(
      InformationalWebLabels.TSPNAME,
      this.selectedTsp?.shortName
    );
    this.notices$ = this._store.pipe(
      select(getNoticesByTspId(this.selectedTsp?.providerId)),
      map((element) => {
        return element?.notices;
      })
    );
    this.fetchNoticesData();
  }

  downloadData(id: number) {
    this._fileService.dispatchDownloadDocument(id, InformationalWebLabels.DOWNLOADTYPENOTICE);
  }

  fetchNoticesData() {
    const { pageNumber, pageSize } = getPagination();
    const filters: NoticeFilterRequest = {
      tspId: this.selectedTsp.providerId,
      filterSupersededTerminatedNotices: true,
      noticeCategory: InformationalWebLabels.POSTING_CRITICAL_PLANNED_SERVICE_CATEGORY,
      pageNumber: pageNumber,
      pageSize: pageSize,
      sortDescending: true,
    };

    this._store.dispatch(fetchAllNotices({ note: filters }));
  }
}
